export enum FamilyCompositionEnum {
    SinglePerson = '1ZON',
    SinglePersonWithChildren = '1MET',
    TwoPersons = '2ZON',
    TwoPersonsWithChildren = '2MET',
}
